export default {
    appHeader: {
        title: 'Solvis ER — Futures nadzorna ploča',
        signOut: 'Odjava',
        loading: 'Učitavanje…',
    },
}
